import renderAndEnableListingTiles from '../listing_tile_rendering/listingTileRenderer'
import { initiateSimilarSearch, buildFilters } from '../../utils/search/helpers'

export default function initSimilarToSoldListingsModule () {
  const similarToSoldListingContainer = document.getElementById('vjs-similar-to-sold-listings')
  if (similarToSoldListingContainer) loadSimilarToSoldListings(similarToSoldListingContainer)
}

function loadSimilarToSoldListings (similarToSoldSection) {
  const {
    listingId, listingTitle, productType, subProductType, subcategory
  } = similarToSoldSection.dataset
  const filters = buildFilters({ listingId, productType, subProductType, subcategory })

  const hitsPerPage = 20
  initiateSimilarSearch(listingTitle, hitsPerPage, filters).then(results => {
    const queryID = results.queryID ? results.queryID : ''
    results.hits.forEach((hit, index) => {
      hit.__position = index + 1
      hit.__queryID = queryID
    })

    renderSection(results, similarToSoldSection)

    const secondarySimilarSection = document.getElementById('vjs-similar-listings-section')
    renderSection(results, secondarySimilarSection)
  })
}

function renderSection (algoliaResults, section) {
  const { hitsPerPage } = section.dataset

  const hits = algoliaResults.hits.slice(0, hitsPerPage)

  renderAndEnableListingTiles(section, hits)
  import(/* webpackChunkName: "carousels" */ '../carousels').then(module => module.initPDPViewMoreCarousel(section))
}
